import ManageCustomerReports from "../pages/reports/customerReports/ManageCustomerReports";
import RunCustomerReports from "../pages/reports/customerReports/RunCustomerReports";
import ManageCustomReports from "../pages/reports/customReportBuilder/ManageCustomReports";
import CreateCustomReport from "../pages/reports/customReportBuilder/CreateCustomReport";
import EditCustomReport from "../pages/reports/customReportBuilder/EditCustomReport";
import ViewCustomReport from "../pages/reports/customReportBuilder/ViewCustomReport";
import ManageLoanReports from "../pages/reports/loanReports/ManageLoanReports";
import RunLoanReports from "../pages/reports/loanReports/RunLoanReports";
import RunCasaReports from "../pages/reports/casaReports/RunCasaReports";
import ManageCasaReports from "../pages/reports/casaReports/ManageCasaReports";
import ManageFinanceReports from "../pages/reports/financeReports/ManageFinanceReports";
import RunFinanceReports from "../pages/reports/financeReports/RunFinanceReports";
import ManageComplianceReports from "../pages/reports/complianceReports/ManageComplianceReports";
import RunComplianceReports from "../pages/reports/complianceReports/RunComplianceReports";
import ManageWalletReports from "../pages/reports/walletReports/ManageWalletReports";
import RunWalletReports from "../pages/reports/walletReports/RunWalletReports";
import RunDepositReports from "../pages/reports/depositReports/RunDepositReports";
import ManageDepositReports from "../pages/reports/depositReports/ManageDepositReports";
import ManageSecurityReports from "../pages/reports/securityReports/ManageSecurityReports";
import RunSecurityReports from "../pages/reports/securityReports/RunSecurityReports";
import ManageOperationsReports from "../pages/reports/operationsReports/ManageOperationsReports";
import RunOperationsReports from "../pages/reports/operationsReports/RunOperationsReports";
import ManageTreasuryReports from "../pages/reports/treasuryReports/ManageTreasuryReports";
import RunTreasuryReports from "../pages/reports/treasuryReports/RunTreasuryReports";
import ManagePaymentReports from "../pages/reports/paymentReports/ManagePaymentReports";
import RunPaymentReports from "../pages/reports/paymentReports/RunPaymentReports";
import ManageAgencyBankingReports from "../pages/reports/agencyBankingReports/ManageAgencyBankingReports";
import RunAgencyBankingReports from "../pages/reports/agencyBankingReports/RunAgencyBankingReports";

export default [
  {
    path: "/loan-reports",
    component: ManageLoanReports,
    isProtected: true,
  },
  {
    path: "/run-loan-reports",
    component: RunLoanReports,
    isProtected: true,
  },
  {
    path: "/casa-reports",
    component: ManageCasaReports,
    isProtected: true,
  },
  {
    path: "/run-casa-reports",
    component: RunCasaReports,
    isProtected: true,
  },
  {
    path: "/finance-reports",
    component: ManageFinanceReports,
    isProtected: true,
  },
  {
    path: "/run-finance-reports",
    component: RunFinanceReports,
    isProtected: true,
  },
  {
    path: "/deposit-reports",
    component: ManageDepositReports,
    isProtected: true,
  },
  {
    path: "/run-deposit-reports",
    component: RunDepositReports,
    isProtected: true,
  },
  {
    path: "/security-reports",
    component: ManageSecurityReports,
    isProtected: true,
  },
  {
    path: "/run-security-reports",
    component: RunSecurityReports,
    isProtected: true,
  },
  {
    path: "/operations-reports",
    component: ManageOperationsReports,
    isProtected: true,
  },
  {
    path: "/run-operations-reports",
    component: RunOperationsReports,
    isProtected: true,
  },
  {
    path: "/treasury-reports",
    component: ManageTreasuryReports,
    isProtected: true,
  },
  {
    path: "/run-treasury-reports",
    component: RunTreasuryReports,
    isProtected: true,
  },
  {
    path: "/payments-reports",
    component: ManagePaymentReports,
    isProtected: true,
  },
  {
    path: "/run-payments-reports",
    component: RunPaymentReports,
    isProtected: true,
  },
  {
    path: "/agency-banking-reports",
    component: ManageAgencyBankingReports,
    isProtected: true,
  },
  {
    path: "/run-agency-banking-reports",
    component: RunAgencyBankingReports,
    isProtected: true,
  },
  {
    path: "/compliance-reports",
    component: ManageComplianceReports,
    isProtected: true,
  },
  {
    path: "/run-compliance-reports",
    component: RunComplianceReports,
    isProtected: true,
  },
  {
    path: "/wallet-reports",
    component: ManageWalletReports,
    isProtected: true,
  },
  {
    path: "/run-wallet-reports",
    component: RunWalletReports,
    isProtected: true,
  },
  {
    path: "/customer-reports",
    component: ManageCustomerReports,
    isProtected: true,
  },
  {
    path: "/create-custom-report",
    component: CreateCustomReport,
    isProtected: true,
  },
  {
    path: "/edit-custom-report",
    component: EditCustomReport,
    isProtected: true,
  },
  {
    path: "/view-custom-report",
    component: ViewCustomReport,
    isProtected: true,
  },
  {
    path: "/custom-report-builder",
    component: ManageCustomReports,
    isProtected: true,
  },
  {
    path: "/run-customer-reports",
    component: RunCustomerReports,
    isProtected: true,
  },
];
